var render = function render(){
  var _vm$debt;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Refixácia")]), _c('button', {
    staticClass: "w-button saveformBtn",
    attrs: {
      "form": "refixation-submit"
    }
  }, [_vm._v("Aktualizovať")])]), _c('form', {
    attrs: {
      "id": "refixation-submit"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveRefixation.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "najomne"
    }
  }, [_vm._v(" Nová úroková sadzba ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.sadzba_schvalena,
      expression: "form.sadzba_schvalena",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "0",
      "max": "99.99",
      "inputmode": "decimal",
      "maxlength": "256",
      "required": ""
    },
    domProps: {
      "value": _vm.form.sadzba_schvalena
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "sadzba_schvalena", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "najomne"
    }
  }, [_vm._v(" Trvanie novej fixácie (roky) ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.fix,
      expression: "form.fix"
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "40",
      "step": "1",
      "maxlength": "256",
      "required": ""
    },
    domProps: {
      "value": _vm.form.fix
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "fix", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "zaciatok-fixacie"
    }
  }, [_vm._v(" Začiatok novej fixácie ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.zaciatok_fixacie,
      expression: "form.zaciatok_fixacie"
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "id": "zaciatok-fixacie",
      "type": "date",
      "min": ((_vm$debt = _vm.debt) === null || _vm$debt === void 0 ? void 0 : _vm$debt.zaciatok) || null,
      "max": _vm.today,
      "required": ""
    },
    domProps: {
      "value": _vm.form.zaciatok_fixacie
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "zaciatok_fixacie", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "nova-splatka"
    }
  }, [_vm._v(" Nová splátka ")]), _c('input', {
    staticClass: "text-input w-input input-color-disabled",
    attrs: {
      "id": "nova-splatka",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.formattedPayment
    }
  }), _c('div', {
    staticClass: "refixation-hint"
  }, [_vm._v(" Počíta sa zo zostatku " + _vm._s(_vm._f("dotTheAmount")(_vm.numericBalance)) + " EUR a zo zostávajúcich " + _vm._s(_vm.remainingMonths) + " mesiacov. Server výpočet pri uložení ešte overí podľa splátkového kalendára. ")])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }